import attachCategory from "./attachCategory";
import create from './create'
import toggle from './toggle'

export default {
    attachCategory,
    create,
    toggle
}